export enum ActiveTestNames {
    newRequestForm = 'newRequestForm',
    estimatedPrice = 'estimatedPrice',
}

export const activeTests = [
    {
        name: ActiveTestNames.newRequestForm,
        testId: 100441493,
        originalVariationId: 1004103824,
        newVariationId: 1004103825,
    },
    {
        name: ActiveTestNames.estimatedPrice,
        testId: 100414399,
        originalVariationId: 100440651,
        newVariationId: 100440652,
    },
];

export type ActiveTest = {
    name: ActiveTestNames;
    testId: number;
    variationGroup: number;
    originalVariationId: number;
    newVariationId: number;
};

export type IabTests = {
    [key in ActiveTestNames]?: ActiveTest;
};
